import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs/index';
import { catchError, tap } from 'rxjs/internal/operators';
import { EnvironmentService } from '../environment.service';

@Injectable({
    providedIn: 'root'
})

export class ConnectorService {
    // store the URL so we can redirect after logging in
    redirectUrl: string;
	err: any;
    apiUrl;
	username;
	password;
    httpOptions;

    constructor(private http: HttpClient, private envService: EnvironmentService) {
        this.apiUrl = this.envService.read('apiUrl');
		this.username = this.envService.getCredential('username');
		this.password = this.envService.getCredential('password');
        this.setHttpHeaders();
    }

    setHttpHeaders() {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
				'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
            })
        };
    }

	getAllConnector(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/list`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getAllConnector', this.err))
            );
    }

    addConnectorDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/create`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('addConnectorDetails', this.err))
            );
    }

    viewConnectorDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('viewConnectorDetails', this.err))
            );
    }

    validateConnectorDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/validate/connector`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('validateConnectorDetails', this.err))
            );
    }

    validatePublicKey(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/validate/publicKey`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('validatePublicKey', this.err))
            );
    }

    deleteConnector(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/delete`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('deleteConnector', this.err))
            );
    }

    updateConnectorDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/update`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateConnectorDetails', this.err))
            );
    }

    publishConnectorDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/publish/request`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('publishConnectorDetails', this.err))
            );
    }

    cancelPublishRequest(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/cancel/publish/request`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('cancelPublishRequest', this.err))
            );
    }

    updatePublish(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/update/publish/request`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updatePublish', this.err))
            );
    }

    cancelPublishUpdate(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/cancel/update/publish/request`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('cancelPublishUpdate', this.err))
            );
    }

    getCapabilities(): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/capabilities`,{},
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getCapabilities', this.err))
            );
    }

    getUsedByApplicationsList(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/connector/usedby/applications`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getUsedByApplicationsList', this.err))
            );
    }

    uploadConnectorIcon(args): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/connector/update/icon`,args,
        this.httpOptions).pipe(
            tap(),
            catchError(this.handleError('uploadConnectorIcon', this.err))
        );
    }
    
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error('error on operation', operation, error); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
